import { render, staticRenderFns } from "./UserTrainingStatsCard.vue?vue&type=template&id=bde5dd7c&scoped=true&"
import script from "./UserTrainingStatsCard.vue?vue&type=script&lang=js&"
export * from "./UserTrainingStatsCard.vue?vue&type=script&lang=js&"
import style0 from "./UserTrainingStatsCard.vue?vue&type=style&index=0&id=bde5dd7c&lang=scss&scoped=true&"
import style1 from "./UserTrainingStatsCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde5dd7c",
  null
  
)

export default component.exports